module.exports = __webpack_public_path__ + "static/media/Bicocca - white_Navy.974df54b.jpg";